import React, { FC, useEffect } from "react";
import { createRoot } from 'react-dom/client';

import { HashRouter, useNavigate } from "react-router";
import "./config/dayjs";
import "@uppy/core/dist/style.css";
// import "@uppy/dashboard/dist/style.css";
import "./assets/base.scss";
import Main from "Layout/MainPage";
import ErrorBoundary from "components/ErrorBoundary";
import configureStore from "./config/configureStore";
import { setNavigate } from "./config/navigate";
import { Provider } from "react-redux";
import createInterceptors from "./config/token-interceptors";
import { installChunkErrorListener } from "utils/chunkErrorRecovery";

installChunkErrorListener();

const store = configureStore();
const interceptors = createInterceptors(store);
const root = createRoot(document.getElementById("root") as HTMLElement);

// Bridges React Router v7's useNavigate to a module-level singleton so Redux
// thunks (auth) can navigate without holding a React reference. See
// src/config/navigate.ts.
const NavigateSetter: FC = () => {
  const navigate = useNavigate();
  useEffect(() => { setNavigate(navigate); }, [navigate]);
  return null;
};

const App: FC = () => {
  return (<Provider store={store}>
    <ErrorBoundary>
      <HashRouter>
        <NavigateSetter />
        <Main />
      </HashRouter>
    </ErrorBoundary>
  </Provider>);
};

root.render(<App />);
